__webpack_require__.p = "https://certificate.quantstamp.com/full/subscription-token-protocol-v-2/7ef99de3-7f40-434b-9931-cd91a798940b/";